<template>
  <v-dialog
    v-model="value"
    :persistent="true"
    width="800"
    content-class="remove-from-filial-menu-dialog"
    @close="close"
  >
    <v-card class="remove-from-filial-menu-dialog_inner">
      <loader v-if="loading" absolute />
      <div class="remove-from-filial-menu-dialog_title">
        Хотите удалить “{{ menuItem.name }}” из меню филиала?
      </div>

      <v-card-actions class="remove-from-filial-menu-dialog_actions">
        <div class="remove-from-filial-menu-dialog_actions_buttons">
          <v-btn
            class="remove-from-filial-menu-dialog_btn remove-from-filial-menu-dialog_btn__cancel"
            large
            depressed
            @click="close"
          >
            Отмена
          </v-btn>
          <v-btn
            color="#ff005f"
            class="remove-from-filial-menu-dialog_btn remove-from-filial-menu-dialog_btn__confirm"
            depressed
            large
            @click="confirm"
          >
            <font-awesome-icon icon="trash" />
            Удалить
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import IconKitchen from '@/components/aside/icons/IconKitchen.vue'

  export default {
    name: 'RemoveFromFilialMenuDialog',
    components: { IconKitchen, Loader },
    emits: [
      'confirm',
      'close',
    ],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      menuItem: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value (val) {
        if (val) {
          this.reason = null
        }
      },
    },
    methods: {
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },
      confirm () {
        this.$emit('confirm', this.menuItem.id)
      },
    },
  }
</script>

<style scoped lang="less">
.remove-from-filial-menu-dialog {

  &_inner {
    padding: 30px 30px 20px 30px;
    border-radius: 10px;
  }

  &_title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 50px;
  }

  &_actions {
    display: flex;
    padding: 0 12%;

    &_buttons {
      flex-grow: 1;
      display: flex;
      align-items: center;
    }
  }

  &_btn {
    flex-grow: 1;
    flex-basis: calc(50% - 40px);
    font-weight: 500;
    font-size: 20px;
    text-transform: none;
    margin: 0 10px;

    &__confirm {
      color: white;
      svg {
        height: 24px;
        width: 40px;
        margin-right: 10px;
      }
    }
  }

}
</style>
